import React from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';

interface Props {
  currentPdfIndex: number;
  currentPageNumber: number;
  totalNumberOfPdfs: number;
  totalNumberOfPagesInCurrentPdf: number;
  selectDocumentAtIndex: (index: number) => void;
  selectPage: (pageNumber: number) => void;
}

interface State {
  currentPdfIndex: number;
  currentPageNumber: number;
}

export default class Counter extends React.Component<Props, State> {
  currentPdfIndexRef: React.RefObject<HTMLInputElement | null> = React.createRef();

  currentPageNumberRef: React.RefObject<HTMLInputElement | null> = React.createRef();

  state: State = {
    currentPdfIndex: this.props.currentPdfIndex,
    currentPageNumber: this.props.currentPageNumber,
  };

  onCurrentPdfIndexChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPdfIndex = parseInt(event.target.value, 10) - 1;
    if (
      Number.isNaN(newPdfIndex) ||
      newPdfIndex < 0 ||
      newPdfIndex > this.props.totalNumberOfPdfs - 1 ||
      newPdfIndex === this.props.currentPdfIndex
    ) {
      return;
    }

    this.setState({ currentPdfIndex: newPdfIndex });
  };

  onCurrentPdfIndexKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      this.props.selectDocumentAtIndex(this.state.currentPdfIndex);
    }
  };

  onCurrentPdfIndexBlur = () => {
    this.props.selectDocumentAtIndex(this.state.currentPdfIndex);
  };

  onCurrentPdfIndexFocus = () => {
    this.currentPdfIndexRef && this.currentPdfIndexRef.current && this.currentPdfIndexRef.current.select();
  };

  onCurrentPageNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const pageNumber = parseInt(event.target.value, 10) - 1;
    if (
      Number.isNaN(pageNumber) ||
      pageNumber < 0 ||
      pageNumber > this.props.totalNumberOfPagesInCurrentPdf - 1 ||
      pageNumber === this.props.totalNumberOfPagesInCurrentPdf
    ) {
      return;
    }

    this.setState({ currentPageNumber: pageNumber });
  };

  onCurrentPageNumberKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.which === 13) {
      this.props.selectPage(this.state.currentPageNumber);
    }
  };

  onCurrentPageNumberBlur = () => {
    this.props.selectPage(this.state.currentPageNumber);
  };

  onCurrentPageNumberFocus = () => {
    this.currentPageNumberRef && this.currentPageNumberRef.current && this.currentPageNumberRef.current.select();
  };

  render() {
    let counter;

    if (
      Number.isInteger(this.state.currentPdfIndex) &&
      Number.isInteger(this.props.totalNumberOfPdfs) &&
      this.props.totalNumberOfPdfs > 0
    ) {
      const docHelptext = `of ${this.props.totalNumberOfPdfs}`;
      const documentCounter = (
        <TextField
          variant="standard"
          id="documentCounter"
          value={this.state.currentPdfIndex + 1}
          autoComplete="off"
          onChange={this.onCurrentPdfIndexChange}
          onKeyPress={this.onCurrentPdfIndexKeyPress}
          onFocus={this.onCurrentPdfIndexFocus}
          onBlur={this.onCurrentPdfIndexBlur}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">Document</InputAdornment>,
              endAdornment: <InputAdornment position="end">{docHelptext}</InputAdornment>,
            },

            htmlInput: { style: { textAlign: 'right' } },
          }}
          inputRef={this.currentPdfIndexRef}
        />
      );

      const pageHelpText = `of ${this.props.totalNumberOfPagesInCurrentPdf}`;
      const pageCounter = (
        <TextField
          variant="standard"
          id="pageCounter"
          value={this.state.currentPageNumber + 1}
          autoComplete="off"
          onChange={this.onCurrentPageNumberChange}
          onKeyPress={this.onCurrentPageNumberKeyPress}
          onFocus={this.onCurrentPageNumberFocus}
          onBlur={this.onCurrentPageNumberBlur}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">Page</InputAdornment>,
              endAdornment: <InputAdornment position="end">{pageHelpText}</InputAdornment>,
            },

            htmlInput: { style: { textAlign: 'right' } },
          }}
          inputRef={this.currentPageNumberRef}
        />
      );

      counter = (
        <Box sx={{ display: 'flex', width: '90%', m: 'auto' }}>
          <Box sx={{ display: 'flex', flex: 5, mr: 2 }}>{documentCounter}</Box>
          <Box sx={{ display: 'flex', flex: 4 }}>{pageCounter}</Box>
        </Box>
      );
    }

    return <div>{counter}</div>;
  }
}
